module.exports = __webpack_public_path__ + "img/hys-2.2ff42420.jpg";